import React, {ReactNode, useEffect} from 'react';
import Page from '@episerver/spa-core/Page';
import TransactionSummaryPageData from "../../../Models/Content/TransactionSummaryPageData";
import TransactionSummary from './TransactionSummary';

export default class TransactionSummaryPage extends Page<TransactionSummaryPageData> {
    public render(): ReactNode {
        return  <TransactionSummary context={this.getContext()} contentData={this.props.data}/>
      }
}
